import { translate } from 'loankeeper-common/helpers'

export const translateLKM = (key) => translate(`LKMESSAGE-${key}`)
